import { gql, useLazyQuery } from '@apollo/client';
import { useEffect } from 'react';
import { useGlobalActions } from '../../global-context/GlobalContext';

const GET_SPECIAL_ORDER = gql`
  query getSpecialOrderProducts($weekDate: DateTime!, $day: Int!) {
    getSpecialOrderProducts(
      getSpecialOrderProductsArgs: { weekDate: $weekDate, day: $day }
    ) {
      message
      status
      statusCode
      error
      data {
        subscriptionProductIds
        deliveryCharge {
          repeatingOrderDeliveryCharge
          standardDeliveryCharge
        }
        list {
          productId
          productName
          productDescription
          productImage
          productType
          mealType
          mealTypeImage
          productIngredients
          productIngredientDetails {
            ingredientName
            isAllergenic
            ingredientId
            showPercent
            quantityPercentage
          }
          jarSize
          price
          isAllergic
          specialOrderId
          specialOrderQuantity
          productDietary {
            healthLabels
            calories
            protein
            gras
            nutritions {
              label
              quantity
              dailyQuantity
            }
          }
          productFeatures {
            name
            image
          }
          allergicItems {
            name
            image
          }
          productNames {
            en {
              name
              description
            }
            fr {
              name
              description
            }
            de {
              name
              description
            }
          }
        }
        specialOrder {
          id
          companyId
          weekDate
          orderDay
          orderDate
          comments
          internalComments
          deliveryCharge
          totalAmount
          createdByResourceType
          createdByResourceId
          createdByResourceEmail
          createdAt
          modifiedAt
          modifiedBy
          specialOrderLines {
            specialOrderLineId
            specialOrderId
            productId
            price
            quantity
            customerOrderedQuantity
            subTotalAmount
            isDeleted
            createdAt
            modifiedAt
          }
        }
        specialOrderRules {
          productType
          isFruit
          minQuantity
        }
      }
    }
  }
`;

export const useGetSpecialOrderProducts = () => {
  const [getSpecialOrderProducts, { error, data, loading }] =
    useLazyQuery(GET_SPECIAL_ORDER);
  const {
    setExistingOrderOnDay,
    handleSetExistingComment,
    setSpecialOrderId,
    setDeliveryCharges,
    setSpecialOrderRules,
  } = useGlobalActions();

  console.log('data in useGetSpecialOrderProducts', data);

  useEffect(() => {
    setExistingOrderOnDay(data ? data?.getSpecialOrderProducts?.data.list : []);
    setSpecialOrderId(data?.getSpecialOrderProducts?.data?.specialOrder?.id);
    handleSetExistingComment(
      data?.getSpecialOrderProducts?.data?.specialOrder?.comments ?? '',
    );
    setDeliveryCharges({
      standardDeliveryCharge:
        data?.getSpecialOrderProducts?.data?.deliveryCharge
          .standardDeliveryCharge ?? 0,
      repeatingOrderDeliveryCharge:
        data?.getSpecialOrderProducts?.data?.deliveryCharge
          .repeatingOrderDeliveryCharge ?? 0,
      previousDeliveryCharge:
        data?.getSpecialOrderProducts?.data?.specialOrder?.deliveryCharge ?? 0,
      subscriptionProductIds:
        data?.getSpecialOrderProducts?.data?.subscriptionProductIds ?? [],
    });

    setDeliveryCharges({
      standardDeliveryCharge:
        data?.getSpecialOrderProducts?.data?.deliveryCharge
          .standardDeliveryCharge ?? 0,
      repeatingOrderDeliveryCharge:
        data?.getSpecialOrderProducts?.data?.deliveryCharge
          .repeatingOrderDeliveryCharge ?? 0,
      previousDeliveryCharge:
        data?.getSpecialOrderProducts?.data?.specialOrder?.deliveryCharge ?? 0,
      subscriptionProductIds:
        data?.getSpecialOrderProducts?.data?.subscriptionProductIds ?? [],
    });
    setSpecialOrderRules(
      data?.getSpecialOrderProducts?.data?.specialOrderRules ?? [],
    );
  }, [data]);

  return {
    getSpecialOrderProducts,
    error,
    specialOrderProducts: data ? data?.getSpecialOrderProducts?.data?.list : [],
    loading,
  };
};
